import React, { useEffect } from "react";
import { ProductWarrantyStoreNameFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";

const ProductWarrantyStoreNameForm = ({ inititalValues, onSubmit }) => {
  const schema = yup.object().shape({
    store_name_by_admin: yup.string().required("Required"),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (inititalValues) {
      reset({ ...inititalValues });
    }
  }, [inititalValues]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ProductWarrantyStoreNameFormStyled>
      <form>
        <div className="f_title">Edit - Store Name</div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                disabled={true}
                label={"Store Name by Customer"}
                // errors={errors.phone?.message}
              />
            )}
            name="store_name"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"New Store name by Admin"}
                errors={errors.store_name_by_admin?.message}
              />
            )}
            name="store_name_by_admin"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Admin Note"}
                // errors={errors.phone?.message}
              />
            )}
            name="store_name_note"
            defaultValue=""
          />
        </div>
        <div className="btn_submit">
          <Buttons.BgStandard
            type="button"
            label={"Update and Save"}
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </form>
    </ProductWarrantyStoreNameFormStyled>
  );
};

ProductWarrantyStoreNameForm.propTypes = {};

export default ProductWarrantyStoreNameForm;
